import { tr, ru, en } from '../../assets/images';

enum enumCommentFlowStatus {
    approved = 0,
    noComment = 1,
    pending = 2,
    rejected = 3,
}

enum enumStarScoreFlowStatus {
    minusOne = -1,
    one = 1,
    two = 2,
    three = 3,
    four = 4,
    five = 5,
}

enum enumCommentStatusFlowStatus {
    minusOne = -1,
    one = 1,
    two = 2,
    three = 3,
}

enum enumCommentGrievanceStatusFlowStatus {
    minusOne = -1,
    zero = 0,
    one = 1,
    two = 2,
    three = 3,
}
enum enumAgenctStatusList {
    all = -1,
    yes = 1,
    no = 0,
}
enum enumCommentRoleID {
    DEV = 45,
    TEST = 45,
    PREPROD = 3,
    PROD = 3,
}
enum enumRefundReason {
    CancelOrder = 1, //order
    Return = 2, //return
    Other = 3,
    RefundOfPartialShipment = 4, //order
    OrderAnExtraPayment = 5, //order ama servisten data çek
    CancellationOfPayment = 6,
    CancellationOfPaymentReceived = 7,
    LostPackage = 8, //order
    WalletRefund = 9,
    LostPackageReturn = 10,
}

enum enumConvertRefundToWalletTransactionResult {
    Succeeded = 0, //order
    RefundStatusNotVerified = 1, //return
    RefundReasonNotVerified = 2,
    WalletTransactionNotSucceed = 3,
}

enum enumRefundStatusType {
    None = -1,
    ProcessingPayment = 0,
    PaymentPending = 1,
    PaymentCompleted = 2,
    PendingExpenseBill = 3,
    PendingAccounting = 4,
    Completed = 5,
    Canceled = 6,
    WaitingForBankAccountInformation = 7,
    IncludedToPetition = 8,
    TransformedNotMatchedPayment = 9,
    DefinedForLCWPara = 10,
}

enum enumRefundStatusTypeEN {
    'None' = -1,
    'Processing Payment' = 0,
    'Payment Pending' = 1,
    'Payment Completed' = 2,
    'Pending Expense Bill' = 3,
    'Pending Accounting' = 4,
    'Completed' = 5,
    'Canceled' = 6,
    'Waiting For Bank Account Information' = 7,
    'Included To Petition' = 8,
    'Transformed Not Matched Payment' = 9,
    'Defined For LCW Para' = 10,
}

enum enumRefundStatusTypeTR {
    'Hiçbiri' = -1,
    'Ödeme Gerçekleşiyor' = 0,
    'Ödeme Bekliyor' = 1,
    'İade tamamlandı' = 2,
    'Gider Pusulası Yazdırılmayı Bekliyor' = 3,
    'Muhasebeleşmeyi Bekliyor' = 4,
    'Tamamlandı' = 5,
    'İptal Edildi' = 6,
    'Ödeme Bilgileri Bekleniyor' = 7,
    'Dilekçeye Dahil Edildi' = 8,
    'Eşleşmeyen Ödemeye Çevrildi' = 9,
    'LCW Para Tanımlandı' = 10,
}

enum enumRefundDetailStatusTypeTR {
    'Ödeme Bekliyor' = 1,
    'Ödeme tamamlandı' = 2,
    'Hata Oluştu' = 3,
    'İptal Edildi' = 4,
}
enum enumRefundDetailStatusTypeEN {
    'Pending' = 1,
    'Completed' = 2,
    'Error' = 3,
    'Canceled' = 4,
}

enum enumRefundReasonTypeEN {
    'None' = 0,
    'Order Cancelled' = 1,
    'Return Item' = 2,
    'Other' = 3,
    'Partial Shipment Refund' = 4,
    'Overpaid Order' = 5,
    'Payment Cancelled' = 6,
    'Payment Received Cancelled' = 7,
    'Lost Package' = 8,
    'Wallet Refund' = 9,
    'Shipping Price' = 10,
    'Shipping Cancelled' = 11,
    'Promotion Refund' = 12,
    'Fast Delivery Refund' = 13,
    'Cargo Fee Added' = 14,
}

enum enumRefundReasonTypeTR {
    'Hiçbiri' = 0,
    'Sipariş İptal' = 1,
    'İade' = 2,
    'Diğer' = 3,
    'Kısmi Gönderinin İadesi' = 4,
    'Ekstra Ödeme Siparişi Verme' = 5,
    'Ödemenin İptali' = 6,
    'Alınan Ödemenin İptali' = 7,
    'Kayıp Kargo' = 8,
    'Cüzdan İadesi' = 9,
    'Kargo Fiyatı' = 10,
    'Sevkiyat İptal' = 11,
    'Promosyon İadesi' = 12,
    'Hızlı Teslimat İadesi' = 13,
    'İade Kargo Ücreti' = 14,
}

enum enumPaymentMethodStatus {
    Wire = 1,
    CreditCard = 2,
    Wallet = 3,
    GiftCart = 5,
    Paypal = 6,
    CashOnDelivery = 7,
    Marketplace = 8,
    BKMExpress = 10,
    GarantiPay = 9,
    CashOnStore = 20,
    WebpayRaschet = 21,
    GiftCardWallet = 99,
    Loan = 98,
}
enum enumPaymentMethodStatusTR {
    'Havale/EFT' = 1,
    'Kredi Kartı' = 2,
    'LCW Para' = 3,
    'Hediye Kartı' = 5,
    'Paypal' = 6,
    'Kapıda Ödeme' = 7,
    'Marketplace Ödemesi' = 8,
    'BKMExpress' = 10,
    'Garanti Pay' = 9,
    'Mağazada Ödeme' = 20,
    'İade Para' = 99,
    'Alışveriş Kredisi' = 98,
    'İade Edilemez' = 100,
}

enum enumPaymentMethodStatusEN {
    'Wire' = 1,
    'Credit Card' = 2,
    'Wallet' = 3,
    'Gift Cart' = 5,
    'Paypal' = 6,
    'Cash On Delivery' = 7,
    'Marketplace' = 8,
    'BKMExpress' = 10,
    'GarantiPay' = 9,
    'Cash On Store' = 20,
    'Gift Card Wallet' = 99,
    'Loan' = 98,
    'Non Refundable' = 100,
}
enum enumInstallmentStatus {
    all = 0,
    active = 1,
    passive = 2,
}

enum searchServiceType {
    optionId = '1',
    colorSpecialCode = '2',
    barcode = '3',
    productOptionSizeRef = '4',
    specialCode = '5',
}
enum enumBackOfficeUrl {
    DEV = 'https://backofficepreprod.lcwaikiki.com/',
    PREPROD = 'https://backofficepreprod.lcwaikiki.com/',
    PROD = 'https://backoffice.lcwaikiki.com/',
    TEST = 'https://backofficetest.lcwaikiki.com/',
}

const enumCommentStatusFlowChipColor: any = {
    [enumCommentStatusFlowStatus.one]: { name: 'one', statusType: 'warning' },
    [enumCommentStatusFlowStatus.two]: { name: 'two', statusType: 'success' },
    [enumCommentStatusFlowStatus.three]: { name: 'three', statusType: 'error' },
};

const enumStarScoreFlowStatusName: any = {
    [enumStarScoreFlowStatus.one]: {
        name: 'one',
        statusType: 'warning',
    },
    [enumStarScoreFlowStatus.two]: { name: 'two', statusType: 'success' },
    [enumStarScoreFlowStatus.three]: { name: 'three', statusType: 'secondary' },
    [enumStarScoreFlowStatus.four]: { name: 'four', statusType: 'info' },
    [enumStarScoreFlowStatus.five]: { name: 'five', statusType: 'danger' },
};
const enumCommentStatusFlowStatusName: any = {
    [enumCommentStatusFlowStatus.one]: { name: 'one', statusType: 'warning' },
    [enumCommentStatusFlowStatus.two]: { name: 'two', statusType: 'approved' },
    [enumCommentStatusFlowStatus.three]: { name: 'three', statusType: 'danger' },
};

const enumCommentGrievanceStatusFlowStatusName: any = {
    [enumCommentGrievanceStatusFlowStatus.one]: {
        name: 'zero',
        statusType: 'warning',
    },
    [enumCommentGrievanceStatusFlowStatus.two]: {
        name: 'one',
        statusType: 'danger',
    },
    [enumCommentGrievanceStatusFlowStatus.three]: {
        name: 'two',
        statusType: 'approved',
    },
};

const enumStarScoreFlowStatusTrName: any = {
    [enumStarScoreFlowStatus.minusOne]: 'Tümü',
    [enumStarScoreFlowStatus.one]: '1 Yıldız',
    [enumStarScoreFlowStatus.two]: '2 Yıldız',
    [enumStarScoreFlowStatus.three]: '3 Yıldız',
    [enumStarScoreFlowStatus.four]: '4 Yıldız',
    [enumStarScoreFlowStatus.five]: '5 Yıldız',
};
const enumCommentStatusFlowStatusTrName: any = {
    [enumCommentStatusFlowStatus.minusOne]: 'Tümü',
    [enumCommentStatusFlowStatus.one]: 'Onay Bekliyor',
    [enumCommentStatusFlowStatus.two]: 'Onaylandı',
    [enumCommentStatusFlowStatus.three]: 'Reddedildi',
};

const enumReturnStatus = [
    { colorCode: '#d4a837', value: 0 }, //beklemede
    { colorCode: '#d4a837', value: 1 }, //işleme alındı
    { colorCode: '#d4a837', value: 2 }, //ödeme bekliyor
    { colorCode: '#75c693', value: 3 }, //tamamlandı
    { colorCode: '#b54600', value: 4 }, //iptal edildi
    { colorCode: '#d4a837', value: 5 }, //kargo şubesinde
    { colorCode: '#d4a837', value: 6 }, //teslimat şubesinde
    { colorCode: '#d4a837', value: 7 }, //teslim alınmayı bekliyor
    { colorCode: '#75c693', value: 8 }, //teslim alındı
    { colorCode: '#75c693', value: 9 }, //mp iade geri ödeme tamamlandı
    { colorCode: '#d4a837', value: 10 }, //mp iade sevk bekliyor
    { colorCode: '#d4a837', value: 11 }, //Mp İade Kargoya Verildi
    { colorCode: '#d4a837', value: 12 }, //Mp İade Sevk Edildi
    { colorCode: '#75c693', value: 13 }, //Mp İade Satıcıya Teslim Edildi
    { colorCode: '#b54600', value: 14 }, //Mp İade Satıcıya Teslim Edilemedi"
    { colorCode: '#b54600', value: 15 }, //İade Red Sevk Bekliyor"
];

const enumOrderStatus = [
    { colorCode: '#d4a837', value: 0 },
    { colorCode: '#d4a837', value: 1 },
    { colorCode: '#d4a837', value: 2 },
    { colorCode: '#d4a837', value: 3 },
    { colorCode: '#75c693', value: 4 },
    { colorCode: '#d4a837', value: 5 },
    { colorCode: '#b54600', value: 6 },
    { colorCode: '#b54601', value: 7 },
    { colorCode: '#b54602', value: 8 },
    { colorCode: '#d4a837', value: 9 },
    { colorCode: '#d4a837', value: 10 },
    { colorCode: '#d4a837', value: 11 },
    { colorCode: '#d4a837', value: 12 },
    { colorCode: '#d4a837', value: 13 },
    { colorCode: '#d4a837', value: 14 },
    { colorCode: '#d4a837', value: 15 },
    { colorCode: '#d4a837', value: 16 },
    { colorCode: '#d4a837', value: 17 },
    { colorCode: '#b54603', value: 18 },
    { colorCode: '#d4a837', value: 19 },
    { colorCode: '#d4a837', value: 20 },
    { colorCode: '#d4a837', value: 21 },
    { colorCode: '#b54608', value: 22 },
    { colorCode: '#d4a837', value: 23 },
    { colorCode: '#b54605', value: 24 },
    { colorCode: '#d4a837', value: 25 },
    { colorCode: '#d4a837', value: 26 },
    { colorCode: '#d4a837', value: 27 },
];

const enumCommentFlowStatusName: any = {
    [enumCommentFlowStatus.approved]: { name: 'approved', statusType: 'success' },
    [enumCommentFlowStatus.noComment]: {
        name: 'noComment',
        statusType: 'secondary',
    },
    [enumCommentFlowStatus.pending]: { name: 'pending', statusType: 'info' },
    [enumCommentFlowStatus.rejected]: { name: 'rejected', statusType: 'danger' },
};

const enumCommentNameFlowStatusId: any = {
    approved: enumCommentFlowStatus.approved,
    noComment: enumCommentFlowStatus.noComment,
    pending: enumCommentFlowStatus.pending,
    rejected: enumCommentFlowStatus.rejected,
};

const enumCommentFlowStatusTrName: any = {
    [enumCommentFlowStatus.approved]: 'Yorum Yok.',
    [enumCommentFlowStatus.noComment]: 'Onay Bekliyor.',
    [enumCommentFlowStatus.pending]: 'Onaylandı.',
    [enumCommentFlowStatus.rejected]: 'Reddedildi.',
};
const enumCountries = [
    { label: 'Türkçe', src: tr, val: '1', value: 'tr-TR' },
    ///////////////////////////////////////////////////////////{label: "عربي",    src: ar,    val: "12", value: "ar-AR"},
    { label: 'Руѝѝкий', src: ru, val: '6', value: 'ru-RU' },
    { label: 'English', src: en, val: '2', value: 'en-US' },
];

const enumOfsCenterMessageType = [
    { text: 'All', value: 0 },
    { text: 'ReserveProductsReceived', value: 1 },
    { text: 'OrderReceived', value: 2 },
    { text: 'OfsCenterStatusUpdate', value: 3 },
    { text: 'OrderFulfilled', value: 4 },
    { text: 'OrderListShippingCompanyUpdate', value: 5 },
    { text: 'ShippingListShippingCompanyChange', value: 6 },
    { text: 'OrderFailed', value: 7 },
    { text: 'Receipt', value: 8 },
];

const enumECommerceMessageType = [
    { text: 'All', value: 0 },
    { text: 'Order', value: 1 },
    { text: 'ReserveProducts', value: 2 },
    { text: 'ExtendReservation', value: 3 },
    { text: 'ECommerceStatusUpdate', value: 4 },
    { text: 'CancelReservation', value: 5 },
    { text: 'ShoppingCartAddProducts', value: 6 },
    { text: 'ShoppingCartRemoveProducts', value: 7 },
    { text: 'SendDocument', value: 8 },
    { text: 'SendPackageLabel', value: 9 },
    { text: 'SaleOrderCutOverTimeUpdate', value: 10 },
    { text: 'OrderRouteInfo', value: 11 },
    { text: 'ShippingListUpdateCargoCompany', value: 12 },
    { text: 'ShippingListUpdateCargoCompanyForClosedPackages', value: 13 },
    { text: 'ShippingListShippingCompanyChangeResult', value: 14 },
];

export const creditCardTypes = [
    { CreditCardTypeId: 1, CreditCardTypeName: 'Garanti - Bonus' },
    { CreditCardTypeId: 2, CreditCardTypeName: 'Akbank - Axess' },
    { CreditCardTypeId: 3, CreditCardTypeName: 'İş Bankası - Maximum' },
    { CreditCardTypeId: 4, CreditCardTypeName: 'HSBC - Advantage' },
    { CreditCardTypeId: 5, CreditCardTypeName: 'Halkbank' },
    { CreditCardTypeId: 7, CreditCardTypeName: 'Yapı Kredi - WorldCard' },
    { CreditCardTypeId: 8, CreditCardTypeName: 'Diğer' },
    { CreditCardTypeId: 9, CreditCardTypeName: 'Finansbank - CardFinans' },
    { CreditCardTypeId: 10, CreditCardTypeName: 'Diğer-USD' },
    { CreditCardTypeId: 11, CreditCardTypeName: 'Diğer-EUR' },
    { CreditCardTypeId: 14, CreditCardTypeName: 'Ziraat' },
    { CreditCardTypeId: 15, CreditCardTypeName: 'Yapi Kredi - WorldCard Eko' },
    { CreditCardTypeId: 100, CreditCardTypeName: 'Yapı Kredi' },
    { CreditCardTypeId: 101, CreditCardTypeName: 'Garanti BBVA' },
    { CreditCardTypeId: 102, CreditCardTypeName: 'Akbank' },
    { CreditCardTypeId: 103, CreditCardTypeName: 'Ziraat Bank' },
    { CreditCardTypeId: 104, CreditCardTypeName: 'Halkbank' },
    { CreditCardTypeId: 105, CreditCardTypeName: 'HSBC' },
    { CreditCardTypeId: 106, CreditCardTypeName: 'QNBFinansbank' },
    { CreditCardTypeId: 107, CreditCardTypeName: 'İş Bankası' },
    { CreditCardTypeId: 110, CreditCardTypeName: 'Vakıf' },
    { CreditCardTypeId: 111, CreditCardTypeName: 'Yapı Kredi - WorldCard' },
    { CreditCardTypeId: 112, CreditCardTypeName: 'Akbank Axess' },
    { CreditCardTypeId: 113, CreditCardTypeName: 'Finansbank CardFinans' },
    { CreditCardTypeId: 201, CreditCardTypeName: 'Corvus Pay' },
];

const enumInstallmentStatusList: any = {
    [enumInstallmentStatus.active]: 'Aktif',
    [enumInstallmentStatus.passive]: 'Pasif',
};

export {
    enumPaymentMethodStatus,
    enumRefundStatusTypeTR,
    enumRefundStatusTypeEN,
    enumRefundStatusType,
    enumConvertRefundToWalletTransactionResult,
    enumReturnStatus,
    enumECommerceMessageType,
    enumOfsCenterMessageType,
    enumCountries,
    enumCommentRoleID,
    enumInstallmentStatus,
    enumCommentStatusFlowChipColor,
    enumStarScoreFlowStatus,
    enumStarScoreFlowStatusTrName,
    enumStarScoreFlowStatusName,
    enumCommentStatusFlowStatusTrName,
    enumCommentStatusFlowStatus,
    enumCommentStatusFlowStatusName,
    enumCommentFlowStatus,
    enumCommentFlowStatusName,
    enumCommentNameFlowStatusId,
    enumCommentFlowStatusTrName,
    enumBackOfficeUrl,
    searchServiceType,
    enumCommentGrievanceStatusFlowStatus,
    enumCommentGrievanceStatusFlowStatusName,
    enumInstallmentStatusList,
    enumRefundReason,
    enumAgenctStatusList,
    enumOrderStatus,
    enumRefundReasonTypeTR,
    enumRefundReasonTypeEN,
    enumPaymentMethodStatusTR,
    enumPaymentMethodStatusEN,
    enumRefundDetailStatusTypeTR,
    enumRefundDetailStatusTypeEN,
};
